export default __webpack_public_path__ + "static/media/2114.beff2c62.png";